<script lang="ts" setup>
import { useAtlas, watch, onMounted, useRouter } from '#imports';
const { viewStyle } = defineProps<{ viewStyle: string }>();
const {
  filteredSpots,
  filterSpots,
  spotCategoryFilter,
  spotDestinationFilter,
  spotCategories,
  spotDestinations,
  spotBookmarks,
  setAtlasMarkers,
  fetchSpots,
} = useAtlas();
const router = useRouter()

onMounted(async () => {
  await fetchSpots();

  watch(
    () => [
      ...spotCategoryFilter.value,
      ...spotDestinationFilter.value
    ],
    () => {
      filterSpots(spotCategoryFilter.value, spotDestinationFilter.value);
    },
    { immediate: true }
  );
})
</script>

<template>
  <h1 :class="[`view-style--${viewStyle}`]">Spots</h1>
  <div class="filters">
    <!-- <MPSelect placeholder="Region" hide-label/> -->
    <MPSelect placeholder="Destinations" v-model="spotDestinationFilter" multiple :options="spotDestinations" hide-label/>
    <MPButton label="Discover Spots" version="secondary" @click="router.push('/explore')"/>
    <!-- <MPButton label="Near Me" outline rounded/> -->
    <!-- <MPButton icon="ri-sort-asc" link rounded/> -->
  </div>
  <div :class="['categories', `view-style--${viewStyle}`]">
    <MPViewportSpill show-inline-control>
      <MPCategoryFilter v-model="spotCategoryFilter" :categories="spotCategories"/>
    </MPViewportSpill>
  </div>
  <div v-if="filteredSpots.length > 0" :class="['spots', `view-style--${viewStyle}`]">
    <div v-for="bookmark in filteredSpots" :key="bookmark.id">
      <MPSpotCard
        :to="`/atlas/spots/${bookmark.current_slug}`"
        version="small"
        show-tier
        :spot="bookmark"
        show-destination
        actions
        :creator="bookmark?.maps?.profiles"
      />
    </div>
  </div>
  <div v-else-if="filteredSpots && filteredSpots.length <= 0">
    <MPEmptyState
      title="No saved Spots"
      subtitle="You do not have any saved spots, Click the heart icon when exploring to add a spot to the atlas"
    />
    <template>
      <MPButton label="Discover Spots" version="secondary" @click="router.push('/explore')"/>
    </template>
  </div>
</template>

<style lang="postcss" scoped>
@import 'assets/css/typography.pcss';

h1 {
  display: block;
  @mixin typeface-h4;
  margin: 0.5rem 0 0.5rem;
  padding: 0.5rem 1rem 0.75rem 1rem;
  border-bottom: 1px solid var(--color-slate-50);
}

h1.view-style--list {
  display: none;
}

.spots {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.5rem 1rem 1rem;

}

.spots.view-style--list {
  grid-template-columns: 1fr;
  @mixin screen md {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @mixin screen lg {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.filters {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0 0 1rem 0;
  padding: 0.5rem 1rem 0.5rem;
  > * {
    max-width: 15rem;
  }
}

.categories {
  align-items: center;
  max-width: 100%;
  padding: 0 1rem;
}
</style>
